import { render, staticRenderFns } from "./StaffTab.vue?vue&type=template&id=013d7b10"
import script from "./StaffTab.vue?vue&type=script&lang=js"
export * from "./StaffTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports